var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"row-cards pa-2"},[_c('FavoriteItem',{attrs:{"item":item}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }